module.exports = __webpack_public_path__ + "static/media/backcat.e62294c7.png";